// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ofjlZ","row":"styles_row__2L0Yk"};